import {
  $post, $get, $JsonPost, vte,
} from '@/utils/axios-request';


class Read {
  // 查询文章列表
  public async getArticleList(postData: any): Promise<any> {
    return await $get(`${vte}/article/api/getArticleList`, postData);
  }

  // 查询文章详情
  public async getArticleDetail(postData: any): Promise<any> {
    return await $get(`${vte}/article/api/getArticleDetail`, postData);
  }

  // 游戏列表
  public async gameList(postData: any): Promise<any> {
    return await $get(`${vte}/game/api/v1/gameList`, postData);
  }

  // 游戏介绍首页
  public async getGameHomePageInfo(postData: any): Promise<any> {
    return await $get(`${vte}/game/api/v1/getGameHomePageInfo`, postData);
  }
}
export default new Read();
